import React from "react";

function SvgIcMapPoi038(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M22.329 10.775c-.268 2.392-.698 2.182-2.837 2.7a14.123 14.123 0 001.381-4.47c1.457.033 1.569.765 1.456 1.77m-12.658.194c-.113-1.012-.002-1.749 1.485-1.77a14.056 14.056 0 001.469 4.5c-2.238-.555-2.681-.296-2.954-2.73M20 23.97v2h-8v-2h8zm.932-18s.1.702.051 1.81c1.96.016 2.755.97 2.553 2.996-.367 3.696-1.269 3.412-4.888 4.151a13.99 13.99 0 01-1.662 2.047v3.103c1.203.254 2.332.945 2.959 1.893h-7.89c.625-.946 1.756-1.637 2.959-1.89v-3.106a14.023 14.023 0 01-1.512-1.823c-3.749-.78-4.665-.433-5.038-4.18-.203-2.03.595-2.984 2.563-2.998-.072-1.22.041-2.003.041-2.003z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi038;
